import { CardGalleryItemProps } from '@wix/design-system';

export type SupportedCardGalleryItemProps = Pick<
  CardGalleryItemProps,
  | 'badge'
  | 'title'
  | 'subtitle'
  | 'suffix'
  | 'backgroundImageUrl'
  | 'backgroundImageNode'
  | 'primaryActionProps'
  | 'secondaryActionProps'
  | 'showSuffixOnHover'
  | 'settingsMenu'
>;
